import React from 'react'
import ContactForm from '../../component/ContactUs/ContactUsForm/ContactForm'
import OurOffices from '../../component/ContactUs/OurGlobalNetwork/OurOffices'
import ContactUsHeader from '../../component/ContactUs/ContactUsHeader/ContactUsHeader'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import ContactusBannerHeader from '../../component/ContactUs/ContactUsHeader/ContactusBannerHeader'
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";

const ContactUsPage = () => {
  return (
    <>
        {/* ✅ Meta Tags for SEO */}
    <Helmet>
  <title>Contact Nextech PLM</title>
  <meta
    name="description"
    content="Connect with Nextech PLM in Pune, India for expert PLM consulting, services, and solutions. Reach out today for inquiries or support."
  />
  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
</Helmet>

    <ToastContainer />
    <ContactusBannerHeader />
    <ContactUsHeader /> 
    <FloatingContactUs />
    <ContactForm />
    <OurOffices />
    </>
  )
}

export default ContactUsPage